import React, { Fragment, useEffect } from "react";
import { Container } from "reactstrap";
import { useDispatch } from "react-redux";
import { searchInput } from "../../actions/uiStateActions";
import ThemeSection from "../../components/ThemeSection/ThemeSection";
import LoadMoreButton from "../../components/LoadMoreButton/LoadMoreButton";
import ProductsLoader from "../../components/ProductSection/ProductsContainer/ProductsLoader";
import ProductTitleLoader from "../../components/ProductSection/ProductSectionTitle/ProductTitleLoader";
import ProductSectionTitle from "../../components/ProductSection/ProductSectionTitle/ProductSectionTitle";
import { ProductCard } from "../../components/ProductCard/ProductCard";
import { SideCart } from "../../components/SideCart/SideCart";
import { useQuery } from "@apollo/react-hooks";
import { SEARCH_QUERY } from "../../queries/searchQuery";
const queryString = require("query-string");

const Search = (props) => {
  const limit = 12;
  const dispatch = useDispatch();
  const params = queryString.parse(props.location.search);
  const searchParam = params.s;

  const { data, loading, error, fetchMore } = useQuery(SEARCH_QUERY, {
    variables: { search: searchParam, limit },
  });

  useEffect(() => {
    if (searchParam) {
      dispatch(searchInput(searchParam));
    }
  });

  if (error) {
    return (
      <div className="SearchContainer">
        <Container>
          <Fragment>
            <ThemeSection>
              <p>Ju lutemi provoni përseri.</p>
            </ThemeSection>
          </Fragment>
        </Container>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="SearchContainer">
        <Container>
          <Fragment>
            <ThemeSection>
              <ProductTitleLoader />
              <ProductsLoader total={limit} />
            </ThemeSection>
          </Fragment>
        </Container>
      </div>
    );
  }

  const products = data?.products?.nodes || [];
  const pageInfo = data?.products?.pageInfo;

  if (products.length === 0) {
    return (
      <div className="SearchContainer">
        <Container>
          <Fragment>
            <ThemeSection>
              <ProductSectionTitle
                isArchive={true}
                title={"Produkti i kerkuar nuk gjendet në stok"}
              />
            </ThemeSection>
          </Fragment>
        </Container>
      </div>
    );
  }

  const handleLoadMore = () => {
    fetchMore({
      variables: { search: searchParam, limit, after: pageInfo.endCursor },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return {
          products: {
            ...fetchMoreResult.products,
            nodes: [...prev.products.nodes, ...fetchMoreResult.products.nodes],
          },
        };
      },
    });
  };

  return (
    <div className="SearchContainer">
      <Container>
        <Fragment>
          <ThemeSection>
            <ProductSectionTitle
              isArchive={true}
              title={"Rezultatet e kërkimit për: " + searchParam}
            />
            <div className="row">
              <div className="col col-md-9 col-12">
                <div className="ProductsGrid">
                  <div className="products">
                    {products.map((product) => (
                      <ProductCard
                        key={product.productId || product.id}
                        product={product}
                      />
                    ))}
                  </div>
                </div>
                {pageInfo?.hasNextPage && (
                  <LoadMoreButton title="Më shumë" loadMore={handleLoadMore} />
                )}
              </div>
              <div className="col col-md-3 col-12">
                <SideCart />
              </div>
            </div>
          </ThemeSection>
        </Fragment>
      </Container>
    </div>
  );
};

export default Search;
